<template>
  <section class="height-100-p" id="rating-search-summary-section">
    <el-row v-if="shipment.currentDetail.rates.header.errorMessage">
      <el-col :gutter="20">
        <el-alert
            :title="$t('invoices.error.ratingError')"
            :description="shipment.currentDetail.rates.header.errorMessage"
            type="error"
            effect="dark"
            :closable="false"
        />
      </el-col>
    </el-row>
    <el-row :gutter="20" class="margin-t-20">
      <el-col :gutter="20">
         <el-button
            v-if="isVisibleEditOptions()"
            :disabled="isEditingRatingOptions"
            class="button-action-default edit-rating-options-button"
            size="mini"
            plain
            @click="handleEditOptions"
          >{{ $t('common.edit') }}
        </el-button>
        <approve-rate :shipment-id="shipmentId" :shipment-status="shipment.currentDetail.header.status" :shipment-non-revenue="shipment.currentDetail.rates.header.nonRevenue" />
      </el-col>
    </el-row>
    <el-form :model="editOptionsForm" ref="editOtionsForm" size="mini" class="search-section-form">
    <el-row :gutter="20" class="margin-t-20">
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.paymentTerms') }}</label>
      </el-col>
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.paymentTerms }} </span>
      </el-col>
      <el-col :span="8" v-if="isEditingRatingOptions">
        <el-form-item :label="$t('customerService.shipment.paymentTerms')">
          <el-select v-model="editOptionsForm.paymentTerms">
            <el-option
              v-for="option in shipmentPaymentTerms"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.invoiceNumberShort') }}</label>
      </el-col>
      <el-col :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.invoiceNumber }} </span>
      </el-col>
      <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.invoiceDate') }}</label>
      </el-col>
      <el-col :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.invoiceDate | moment("MM/DD/YYYY") }} </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4" v-if="(!isEditingRatingOptions) || (isEditingRatingOptions && editOptionsForm.paymentTerms != thirdPartyType)">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.billTo') }}</label>
      </el-col>
      <el-col :span="4" v-if="(!isEditingRatingOptions) || (isEditingRatingOptions && editOptionsForm.paymentTerms != thirdPartyType)">
        <span class="span-small-list">
          <el-tooltip class="item" effect="dark" :content="shipment.currentDetail.rates.header.billToAccountName + ' - ' + shipment.currentDetail.rates.header.billToAccountNumber" placement="top">
            <span> {{ shipment.currentDetail.rates.header.billToAccountName }} - {{ shipment.currentDetail.rates.header.billToAccountNumber }} </span>
          </el-tooltip>
        </span>
      </el-col>
      <el-col :span="8" v-if="isEditingRatingOptions && editOptionsForm.paymentTerms === thirdPartyType">
        <span class="span-small-list">
          <el-form-item :label="$t('customerService.shipment.billTo')" prop="billTo">
            <autocomplete :model.sync="editOptionsForm.billToAccountId"
                :url="urlBillTo"
                labelField="name"
                labelFieldLastWithDash="number"
                valueField="id"
                ref="billToAccount"
            ></autocomplete>
          </el-form-item>
        </span>
      </el-col>
      <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.origin') }}</label>
      </el-col>
      <el-col :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.receivingWarehouseCode }} </span>
      </el-col>
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.nonRevenue') }}</label>
      </el-col>
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.nonRevenue ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
      </el-col>
      <el-col :span="8" v-if="isEditingRatingOptions">
        <el-form-item :label="$t('customerService.shipment.nonRevenue')">
          <el-select v-model="editOptionsForm.nonRevenue">
            <el-option :label="statusBoolean.yes.label" :value="statusBoolean.yes.value"></el-option>
            <el-option :label="statusBoolean.no.label" :value="statusBoolean.no.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.exemptMinimum') }}</label>
      </el-col>
      <el-col :span="4" v-if="!isEditingRatingOptions">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.exemptMinimum ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
      </el-col>
      <el-col :span="8" v-if="isEditingRatingOptions">
        <el-form-item :label="$t('customerService.shipment.exemptMinimum')">
          <el-select v-model="editOptionsForm.exemptMinimum">
            <el-option :label="statusBoolean.yes.label" :value="statusBoolean.yes.value"></el-option>
            <el-option :label="statusBoolean.no.label" :value="statusBoolean.no.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.manualChanges') }}</label>
      </el-col>
      <el-col :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.manualChanges ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.approvedBy" :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.approvedBy') }}</label>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.approvedBy" :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.header.approvedBy }} </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.credited') }}</label>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.credited ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.originalInvoiceNumber') }}</label>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.originalInvoiceNumber }} </span>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <label class="margin-bottom-small-list">{{ $t('customerService.shipment.originalInvoiceDate') }}</label>
      </el-col>
      <el-col v-if="shipment.currentDetail.header.credited" :span="4">
        <span class="span-small-list"> {{ shipment.currentDetail.rates.header.originalInvoiceDate | moment("MM/DD/YYYY") }} </span>
      </el-col>
    </el-row>
    </el-form>
    <span v-if="isEditingRatingOptions" class="edit-rating-options-actions">
      <el-button
        @click="cancelEditOptions()"
        size="mini"
      >{{ $t('common.cancel') }}</el-button>
      <el-button
          type="primary"
          @click="handleUpdateOptions()"
          size="mini"
      >{{ $t('common.save') }}</el-button>
    </span>
    <el-row class="title-list">
      <el-col>
        <el-form
          id="rate-search-section-form"
          class="search-section-form"
          :model="filters"
          ref="filters"
          label-position="right"
          size="mini"
          inline
        >
         <el-row>
           <el-col class="rate-title el-pagination__title" :span="2">
               <span >{{ $t('customerService.shipment.rates') }}</span>
           </el-col>
           <el-col :span="10">
               <el-form-item :label="$t('customerService.shipment.showZeroRates')">
                 <el-select v-model="filters.showRateWithZero" @change="handleSearch">
                   <el-option :label="statusBoolean.yes.label" :value="statusBoolean.yes.value"></el-option>
                   <el-option :label="statusBoolean.no.label" :value="statusBoolean.no.value"></el-option>
                 </el-select>
               </el-form-item>
            </el-col>
            <add-rate
              :shipment-id="shipmentId"
              :shipment-status="shipment.currentDetail.header.status"
              :shipment-non-revenue="shipment.currentDetail.rates.header.nonRevenue"
              :total-units="shipment.currentDetail.rates.header.numberOfUnits"
              :total-cubes="shipment.currentDetail.rates.header.cubes"
              :current-rates="shipment.currentDetail.rates.list"
              :shipment-uom-id="shipment.currentDetail.header.unitOfMeasureId"
            />
            <re-rate :shipment-id="shipmentId" :shipment-status="shipment.currentDetail.header.status" :shipment-non-revenue="shipment.currentDetail.rates.header.nonRevenue" />
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-form :model="editForm" :rules="editFormRules" ref="editForm" @submit.native.prevent>
    <el-table
      :data="shipment.currentDetail.rates.list"
      v-loading="shipment.currentDetail.rates.loadingSearch"
      id="rates-shipment-data-list"
      size="mini"
      tooltip-effect="dark"
      sortable
      class="dark-blue-table shipment-header-vertical-center"
      :empty-text="$t('common.notAbleToFindRecords')"
      stripe
    >
     <el-table-column
        :label="$t('customerService.shipment.chargeCode')"
        :min-width="6"
        align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.chargeCode }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customerService.shipment.rate')"
        :min-width="5"
        align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <el-form-item prop="rate">
              <el-input-number
                v-model="editForm.rate"
                v-numeric-validation
                :controls="false"
                :precision="2"
                @focus="$event.target.select()"
                :min="0" :max="99999.99"
                @change="calculateAmount"
                size="mini"
                class="inline-input"
                id="edit-form-rate"
                ref="rate"
              ></el-input-number>
            </el-form-item>
          </template>
          <template v-else>
            <span v-if="scope.row.unitOfMeasure == unitOfMeasure.CURRENCY">
              {{ formatMoney(scope.row.rate) }}
            </span>
            <span v-if="scope.row.unitOfMeasure == unitOfMeasure.PERCENTAGE">
              {{ scope.row.rate }} {{ unitOfMeasure.PERCENTAGE }}
            </span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customerService.shipment.quantity')"
        :min-width="4"
        align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == rateType.NON_REVENUE.value">
            {{ scope.row.quantity | currency }}
          </span>
          <span v-else>
            {{ scope.row.quantity }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customerService.shipment.amount')"
        :min-width="6"
        align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.edit">
            <span> {{ formatMoney(amountCalculated) }} </span>
          </template>
          <template v-else>
            <span> {{ formatMoney(scope.row.amount) }} </span>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('customerService.shipment.revenue')"
        :min-width="6"
        align="center">
        <template slot-scope="scope">
          <span> {{ scope.row.revenue ? statusBoolean.yes.label : statusBoolean.no.label }} </span>
        </template>
      </el-table-column>
      <el-table-column
            :label="$t('customerService.shipment.createdBy')"
            :min-width="6"
            align="center">
        <template slot-scope="scope">
           <el-tooltip class="item" effect="dark" :content="`${ scope.row.createdBy }`" placement="top">
            <span> {{ scope.row.createdBy }} </span>
           </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
            :label="$t('customerService.shipment.modifiedBy')"
            :min-width="6"
            align="center">
        <template slot-scope="scope">
           <el-tooltip class="item" effect="dark" :content="`${ scope.row.modifiedBy }`" placement="top">
            <span> {{ scope.row.modifiedBy }} </span>
            </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        :min-width="5"
        :label="$t('common.options')"
        align="center"
        class-name="fixed-width">
        <template slot-scope="scope">
          <el-tooltip v-if="showEditDeleteButton()" class="item" effect="dark" :enterable="false" :content="$t('customerService.shipment.editRate')" placement="top-start">
            <i class="el-icon-edit icon-action" @click="handleEdit(scope.row)"></i>
          </el-tooltip>
          <el-tooltip v-if="showEditDeleteButton()" class="item" effect="dark" :enterable="false" :content="$t('customerService.shipment.deleteRate')" placement="top-start">
            <i class="el-icon-delete icon-action" type="primary" size="mini" @click="handleDelete(scope.row.id, scope.row.chargeCode)"></i>
          </el-tooltip>
          <template v-else-if="scope.row.edit">
            <el-button icon="el-icon-success" circle size="mini" @click="handleUpdate()"></el-button>
            <el-button icon="el-icon-circle-close" circle size="mini" @click="cancelEdit(scope.row)"></el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    </el-form>
    <div class="pagination-footer">
      <span class="el-pagination__total" slot>
        <span class="el-pagination__title" slot>{{ $t('customerService.shipment.totalAmount') }}</span>
           {{ formatMoney(shipment.currentDetail.rates.totalAmount) }}
      </span>
      <el-pagination
        @size-change="handleSearchChangeLimit"
        :page-sizes="sizes"
        :page-size="filters.rows"
        :current-page.sync="filters.page"
        @current-change="handleSearchChangePage"
        :total="shipment.currentDetail.rates.total"
        layout="slot, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import Autocomplete from '@/components/Autocomplete';
import apiConstants from '@/utils/apiConstants';
import ApproveRate from './ApproveRate';
import AddRate from './AddRate';
import ReRate from './ReRate';

export default {
  name: 'RatingSummarySection',
  components: {
    AddRate,
    ApproveRate,
    ReRate,
    Autocomplete
  },
  computed: {
    ...mapGetters(['shipment']),
    thirdPartyType() {
      return constants.SHIPMENT.PAYMENT_TERMS[2].value;
    }
  },
  props: {
    shipmentId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      searching: false,
      filters: {
        shipmentId: this.shipmentId,
        showRateWithZero: false,
        page: constants.TABLES.DEFAULT_PAGE,
        rows: constants.TABLES.DEFAULT_LIMIT,
        pageResults: true
      },
      editOptionsForm: {
        exemptMinimum: false,
        nonRevenue: false,
        paymentTerms: constants.SHIPMENT.PAYMENT_TERMS[0].value,
        billToAccountId: null
      },
      editForm: {
        shipmentId: this.shipmentId,
        shipmentRateId: null,
        type: null,
        rate: 0
      },
      editFormRules: {
        number: [
          { required: true, message: this.$t('customerService.shipment.error.rateRequired'), trigger: 'submit' }
        ]
      },
      amountCalculated: 0,
      statusBoolean: constants.STATUS_BOOLEAN,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      rateType: constants.SHIPMENT.RATE_TYPE,
      unitOfMeasure: constants.SHIPMENT.RATE_UNIT_OF_MEASURE,
      isEditingRatingOptions: false,
      shipmentPaymentTerms: constants.SHIPMENT.PAYMENT_TERMS,
      urlBillTo: apiConstants.END_POINTS.ACCOUNTS.BILL_TO,
      uomPalletId: constants.UNIT_OF_MEASURE_LIST_BY_ID[2].value,
      uomBoxId: constants.UNIT_OF_MEASURE_LIST_BY_ID[1].value,
      uomBinId: constants.UNIT_OF_MEASURE_LIST_BY_ID[0].value
    };
  },
  methods: {
    handleSearchChangeLimit(data) {
      this.filters.rows = data;
      this.filters.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(data) {
      this.filters.page = data;
      this.handleSearch();
    },
    handleSearch() {
      this.filters.shipmentId = this.shipmentId;
      this.cancelEditOptions();
      this.$store.dispatch('shipment/searchRatings', this.filters);
    },
    handleEdit(row) {
      this.$store.dispatch('shipment/setEditingRowRate', true);
      row.edit = true;
      this.editForm.shipmentId = this.shipmentId;
      this.editForm.shipmentRateId = row.id;
      this.editForm.rate = row.rate;
      this.editForm.type = row.type;
      this.amountCalculated = row.amount;
      this.$nextTick(() => {
        this.$refs.editForm.$el[0].focus();
      });
    },
    clearEdit() {
      this.$store.dispatch('shipment/setEditingRowRate', false);
      this.editForm.shipmentRateId = null;
      this.editForm.rate = 0;
      this.editForm.type = null;
      this.amountCalculated = 0;
    },
    cancelEdit(row) {
      row.edit = false;
      this.clearEdit();
    },
    showEditDeleteButton() {
      const hasShipmentStatusErrorMasterOrRated = this.shipment.currentDetail.header.status === constants.SHIPMENT.STATUS[2].value || this.shipment.currentDetail.header.status === constants.SHIPMENT.STATUS[3].value || this.shipment.currentDetail.header.status === constants.SHIPMENT.STATUS[4].value;
      const hasPermission = this.$can(this.permissions.BILLING.EDIT_RATING);
      return hasShipmentStatusErrorMasterOrRated && hasPermission && !this.shipment.currentDetail.rates.isEditingRow;
    },
    async handleUpdate() {
      const validForm = await this.$refs.editForm.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      if (this.editForm.rate === 0) {
        const confirm = await this.$confirm(this.$t('customerService.shipment.confirmAddRateZero'), { confirmButtonText: this.$t('common.yes') }).catch(() => {});
        if (!confirm) {
          return;
        }
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch('shipment/updateRate', { ...this.editForm });
        this.$message.success(response.message);
        this.clearEdit();
        this.handleSearch();
      } finally {
        loading.close();
      }
    },
    // This calculation is Informative, Final Quantity and Amount is Calculated in Backend.
    calculateAmount() {
      // UNITS, PALLET, BIN
      if (this.useShipmentTotalUnits()) {
        this.amountCalculated = this.shipment.currentDetail.rates.header.numberOfUnits * this.editForm.rate;
      } else if (this.editForm.type === this.rateType.CUBE.value) {
        // CUBES
        this.amountCalculated = this.shipment.currentDetail.rates.header.cubes * this.editForm.rate;
      } else if (this.editForm.type === this.rateType.NON_REVENUE.value) {
        // NON_REVENUE
        let totalRevenueAmount = 0;
        for (const rate of this.shipment.currentDetail.rates.list) {
          if (rate.type !== this.rateType.NON_REVENUE.value) {
            totalRevenueAmount += rate.amount;
          }
        }
        this.amountCalculated = totalRevenueAmount * (this.editForm.rate / 100);
      } else if (this.editForm.type === this.rateType.TRAILER.value || this.editForm.type === this.rateType.FLAT.value) {
        this.amountCalculated = this.editForm.rate;
      } else {
        this.amountCalculated = 0;
      }
    },
    useShipmentTotalUnits() {
      const { unitOfMeasureId } = this.shipment.currentDetail.header;

      // RATE TYPE UNITS (Always applies no matter if the unitOfMeasureId is BIN or PALLET)
      return this.editForm.type === this.rateType.UNIT.value
        // RATE TYPE PALLET (Applies if the unitOfMeasureId of shipments is UNIT OR PALLET)
        || (this.editForm.type === this.rateType.PALLET.value
          && (unitOfMeasureId === this.uomPalletId || unitOfMeasureId === this.uomBoxId)
        )
        // RATE TYPE BIN (Applies if the unitOfMeasureId of shipments is BIN)
        || (this.editForm.type === this.rateType.BIN.value && unitOfMeasureId === this.uomBinId);
    },
    async handleDelete(id, chargeCode) {
      const confirm = await this.$confirm(this.$t('customerService.shipment.deleteConfirmation').replace('[chargeCode]', chargeCode), { confirmButtonText: this.$t('common.yes') }).catch(() => {});
      if (!confirm) {
        return;
      }
      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      await this.$store.dispatch('shipment/deleteRate', { shipmentId: this.shipmentId, shipmentRateId: id }).catch(() => {});
      this.handleSearch();
      loading.close();
    },
    isVisibleEditOptions() {
      const hasShipmentStatusLessThanClosed = this.shipment.currentDetail.header.status < constants.SHIPMENT.STATUS[5].value;
      const hasPermission = this.$can(this.permissions.BILLING.EDIT_RATING);
      return hasShipmentStatusLessThanClosed && hasPermission;
    },
    handleEditOptions() {
      this.isEditingRatingOptions = true;
      this.editOptionsForm.exemptMinimum = this.shipment.currentDetail.rates.header.exemptMinimum;
      this.editOptionsForm.nonRevenue = this.shipment.currentDetail.rates.header.nonRevenue;
      this.editOptionsForm.billToAccountId = this.shipment.currentDetail.rates.header.billToAccountId;
      this.editOptionsForm.paymentTerms = this.shipmentPaymentTerms.find(element => element.label === this.shipment.currentDetail.rates.header.paymentTerms).value;
      this.$nextTick(() => {
        if (this.editOptionsForm.paymentTerms === this.thirdPartyType) {
          this.$refs.billToAccount.setLocalModel(`${this.shipment.currentDetail.rates.header.billToAccountName} - ${this.shipment.currentDetail.rates.header.billToAccountNumber}`);
        }
      });
    },
    cancelEditOptions() {
      this.isEditingRatingOptions = false;
    },
    async handleUpdateOptions() {
      Message.closeAll();
      let loadingConfig = constants.LOADING.DEFAULT_CONFIG;
      if (this.showRunRatingLoadingConfig()) {
        loadingConfig = constants.LOADING.RUN_RATING_CONFIG;
      }
      const loading = this.$loading(loadingConfig);
      try {
        const response = await this.$store.dispatch('shipment/updateRatingOptions', { optionsToUpdate: this.editOptionsForm, shipmentId: this.shipmentId });
        this.$message.success(response.message);
        await this.$store.dispatch('shipment/searchHeader', this.shipmentId);
        await this.handleSearch();
        this.cancelEditOptions();
      } finally {
        loading.close();
      }
    },
    showRunRatingLoadingConfig() {
      const { status } = this.shipment.currentDetail.header;
      const { nonRevenue, paymentTerms } = this.shipment.currentDetail.rates.header;
      const { nonRevenue: nonRevenueEdited, paymentTerms: paymentTermsEdited } = this.editOptionsForm;
      const statusNotCancelledOpenClosed = ![constants.SHIPMENT.STATUS[1].value, constants.SHIPMENT.STATUS[5].value, constants.SHIPMENT.STATUS[5].value].includes(status);
      const paymentTermsChanged = (this.shipmentPaymentTerms.find(element => element.label === paymentTerms).value !== paymentTermsEdited || paymentTermsEdited === this.thirdPartyType);
      const nonRavenueChangeToFalse = (nonRevenue !== nonRevenueEdited) && !nonRevenueEdited;
      return statusNotCancelledOpenClosed && (paymentTermsChanged || nonRavenueChangeToFalse);
    },
    formatMoney(money) {
      if (money < 0) {
        return `(${this.$options.filters.currency(money).replace('-', '')})`;
      }
      return this.$options.filters.currency(money);
    },
    setShowRateWithZero(showRateWithZero) {
      this.filters.showRateWithZero = showRateWithZero;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  #rating-search-summary-section {
    .title-list {
      margin-bottom: 10px;
    }
    .rate-title {
      text-align: left;
      font-size: 18px;
    }
    .el-alert {
      .el-alert__title {
        text-align: left;
        display: block;
        width: 100% !important;
        font-size: 14px;
      }
      .el-alert__description {
        font-size: 14px;
      }
    }
    .edit-rating-options-button {
      float: right;
      margin-left: 10px;
    }
    .edit-rating-options-actions {
      float: right;
      margin-bottom: 18px;
      button {
        margin-left: 10px;
      }
    }

    .el-form-item {
      margin-bottom: 10px;
      .el-form-item__label {
        width: 50%;
        text-align: right;
        padding-right: 10px;
      }
      .el-form-item__content {
        width: 50%;
        padding-left: 10px;
        input {
          padding-left: 15px;
          font-size: inherit;
        }
      }
    }
  }

  .shipment-header-vertical-center {
    th {
      .cell {
        line-height: 24px !important;
      }
    }
  }
</style>
